import { CatalogType } from '@environment/environment.commons';

// Claves de caché que versiones anteriores dejaban en localStorage (spec 01).
const CATALOG_KEY_PATTERN = new RegExp(`^(${Object.values(CatalogType).join('|')})([0-9a-f]{32})?$`);
const REASONS_KEY_PATTERN = /^reasons-dropdown-cache(_.*)?$/;
const EXACT_KEYS = new Set(['tenant-dropdown-tenants', 'ticketTypeCache', 'storeTypeCache']);

function isLegacyCacheKey(key: string): boolean {
  return EXACT_KEYS.has(key) || CATALOG_KEY_PATTERN.test(key) || REASONS_KEY_PATTERN.test(key);
}

/**
 * Borra de localStorage solo las claves de caché heredadas. Si el storage no está
 * disponible (modo privado, acceso bloqueado) no hace nada: el arranque no debe fallar.
 */
export function clearLegacyCacheKeys(storage?: Storage): void {
  try {
    const target = storage ?? localStorage;
    const legacyKeys: string[] = [];

    for (let i = 0; i < target.length; i++) {
      const key = target.key(i);
      if (key !== null && isLegacyCacheKey(key)) {
        legacyKeys.push(key);
      }
    }

    legacyKeys.forEach(key => target.removeItem(key));
  } catch {
    // Storage inaccesible: no hay nada que limpiar.
  }
}
